import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";

// components
import TaskCard from "../Cards/TaskCard";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import TaskCreateModal from "./TaskCreateModal";
import BaseApi from "../../utils/BaseApi";
import {deleteArrayItemByKeyValue, setArrayKey} from "../../utils/misc";


class TasksTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tasks: [],
            filterFields: null,
            filters: {},
        };
    }

    async componentDidMount() {
        await this.retrieveTasks();
        await this.retrieveFilterFields();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveTasks();
        }
    }

    async retrieveFilterFields() {
        const url = 'task/update_form/';
        const api = new BaseApi();
        let params = {
            fields: JSON.stringify(
            [
                    'executor',
                    'owner',
                ]
            )
        }
        let response = await api.get(url, params);
        let fields = response.data
        fields = deleteArrayItemByKeyValue(
            fields,
            'name',
            'submitButton'
        );
        fields = setArrayKey(
            fields,
            'name',
            'executor',
            'required',
            false,
        )
        fields = setArrayKey(
            fields,
            'name',
            'owner',
            'required',
            false,
        )
        this.setState(
            {
                filterFields: [
                    {
                        name: 'search',
                        label: 'Поисковая строка',
                        xs: 12,
                        sm: null,
                        md: null,
                        lg: null,
                        xl: null,
                        required: false,
                        type: 'input',
                    },
                    ...fields
                ],
            }
        );
    }

    async filterCallBack(filters){
        this.setState({
            filters: filters
        },async () => {
            await this.retrieveTasks();
        });

    }

    async retrieveTasks(page=1) {
        this.setState(
        {
            tasks: null,
            }
        )
        const url = 'task/';
        const api = new BaseApi();
        let params = {
            page_size: 10,
            ordering: '-end_dt',
            page: page,
        };
        params = {...params, ...this.state.filters};
        if ('opportunity' in this.props){
            params.opportunity = this.props.opportunity.id
        }
        if ('accountId' in this.props){
            params.account = this.props.accountId
        }
        if ('executor' in this.props){
            params.executor = this.props.executor.id
        }
        if ('owner' in this.props){
            params.owner = this.props.owner.id
        }
        if ('noPhase' in this.props){
            params.noPhase = this.props.noPhase
        }
        if ('noPhase' in this.props){
            params.noOpportunity = this.props.noOpportunity
        }
        if ('phase' in this.props){
            params.phase = this.props.phase
        }
        let response = await api.get(
            url,
            params
        );
        this.setState(
            {
                tasks: response.data.results,
                pages: response.data.total_pages,
                pageNumber: page,
            }
        );
    }

    render() {
        if (!this.state.tasks || !this.state.filterFields) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                spacing={1}
            >
                {
                    this.props.create?
                        <TaskCreateModal
                            account={this.props.opportunity?this.props.opportunity.account.id:this.props.account?.id}
                            accountObj={this.props.opportunity?this.props.opportunity.account:this.props.account}
                            phase={this.props.phase?.id}
                            phaseObj={this.props.phase}
                            opportunity={this.props.opportunity?.id}
                            opportunityObj={this.props.opportunity}
                            activeStep={(() => {
                                if (!this.props.opportunity){
                                    return 1
                                }
                                if (!this.props.phase){
                                    return 2
                                }
                                return 4
                            })()
                            }
                            lockedSteps={[0, this.props.opportunity?1:null, this.props.phase?2:null, this.props.phase?3:null].filter((a)=>(a !== null))}
                            callBack={this.retrieveTasks.bind(this)}
                        />:
                        null
                }
                <CommonPaginatedComponentList
                    pages={this.state.pages}
                    pageNumber={this.state.pageNumber}
                    data={this.state.tasks}
                    component={TaskCard}
                    componentKeyword={'task'}
                    componentProps={{
                        hideOpportunity: 'opportunity' in this.props,
                    }}
                    paginationCallback={this.retrieveTasks.bind(this)}
                    callBack={this.retrieveTasks.bind(this)}
                    filterFields={this.state.filterFields}
                    filterCallBack={this.filterCallBack.bind(this)}
                />
            </Stack>
        )
    }
}

export default TasksTab;
